import * as React from "react";
import { TrashIcon } from "@heroicons/react/outline";

interface CoverPhotoProps {
  onUpload: (files: File[]) => Promise<void>;
  onDelete: () => void;
  coverPhoto: string | null;
}

const CoverPhoto: React.FC<CoverPhotoProps> = ({
  onUpload,
  onDelete,
  coverPhoto,
}) => {
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      onUpload(Array.from(e.target.files));
    }
  };

  return (
    <div className="relative rounded-lg overflow-hidden w-full aspect-[16/9]">
      {coverPhoto ? (
        <>
          <img
            src={coverPhoto}
            alt="Cover Photo"
            className="w-full h-full object-cover"
          />
          <button
            onClick={onDelete}
            className="absolute top-2 right-2 bg-white p-1 rounded-full hover:bg-gray-200 transition-colors"
          >
            <TrashIcon className="h-5 w-5 text-gray-600" />
          </button>
        </>
      ) : (
        <div className="w-full h-full border-2 border-dashed border-gray-300 flex flex-col items-center justify-center">
          <svg
            className="h-12 w-12 text-gray-400 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <p className="text-gray-600 mb-2">Drag photos here</p>
          <p className="text-gray-500 text-sm mb-4">or</p>
          <label className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600">
            Upload
            <input
              type="file"
              className="hidden"
              onChange={handleFileUpload}
              accept="image/*"
              multiple
            />
          </label>
        </div>
      )}
      <div className="absolute top-2 left-2 bg-white text-xs px-2 py-1 rounded-md shadow">
        Cover Photo
      </div>
    </div>
  );
};

export default CoverPhoto;
